module.exports = __webpack_public_path__ + "img/73200.1959416d.jpg";